import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import Home from './pages/Home';
import TheAdventure from './pages/TheAdventure';
import OurPilots from './pages/OurPilots';
import OurBalloons from './pages/OurBalloons';
import OurHistory from './pages/OurHistory';
import MasaiMara from './pages/MasaiMara';
import ReviewsGallery from './pages/ReviewsGallery';
import FAQs from './pages/FAQs';
import News from './pages/News';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/the-adventure" element={<TheAdventure />} />
          <Route path="/our-pilots" element={<OurPilots />} />
          <Route path="/our-balloons" element={<OurBalloons />} />
          <Route path="/our-history" element={<OurHistory />} />
          <Route path="/masai-mara" element={<MasaiMara />} />
          <Route path="/reviews-gallery" element={<ReviewsGallery />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;